import cfgMagazines from "./cfgMagazines";
import cfgWeapons from "./cfgWeapons";

//      CfgWeapons and cfgMagazines
//      Currently are very primitive
//      Because one weapon can have multiple magazines 
//TODO: weapons should have references to magazines
//?     or not... why would I need that anyway ?

const classes = {
  cfgWeapons,
  cfgMagazines,
};

export default classes;